<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="font-semibold" [for]="resolvedId()">{{ label() }}</label>
  }

  <p-inputgroup>
    @if (icon()) {
      <p-inputgroup-addon>
        <ng-icon [name]="icon()" />
      </p-inputgroup-addon>
    }
    <input
      #i
      pInputText
      [id]="resolvedId()"
      [value]="value()"
      [disabled]="edit()"
      (input)="value.set(i.value)"
      [placeholder]="placeholder() ?? ''" />
  </p-inputgroup>
</div>
